import { UserInfo } from 'firebase'

export class UserData {
  // firstname of the user
  firstname = ''

  // lastname of the user
  lastname = ''

  // salutation
  salutation = ''

  // contactlens left (ID)
  contactlensLeft = -1

  // contactlens right (ID)
  contactlensRight = -1

  // date and time when the terms were accepted
  termsAccepted: Date | null = null

  // true if sending offers is allowed
  allowOffers = false

  // true if sending price notifications is allowed
  allowPriceNotifications = false
}

export interface ProfileState {

  // login user from authentication provider
  user?: UserInfo;

  // user data from the application itself
  data: UserData;

  // is this used anywhere?
  error: boolean;

  // signal to open the authDialog
  openAuth: boolean;

  // target url after successful login
  to: string;
}
